import { getRequest } from ".";
import apiEndpoints from "./apiEndpoints";

export const getSpecificSchedule = (payload) => {
  return getRequest(
    apiEndpoints.schedule.specificSchedule +
      `?month=${payload.month}&year=${payload.year}`
  );
};
